/**
 * SOLY-DOC-002 — print / save helpers for same-origin object URLs (blob:). Printing a cross-origin
 * R2 URL is not scriptable; a blob shown in our own iframe is.
 */

/** Opens the browser print dialog for a PDF already shown in `frame`. Returns false if the browser refused. */
export function printPdfFrame(frame: HTMLIFrameElement | null): boolean {
  const win = frame?.contentWindow
  if (!win) return false
  try {
    win.focus()
    win.print()
    return true
  } catch {
    return false
  }
}

/** Prints one image on its own page through a throw-away iframe (removed after the dialog closes). */
export function printImage(url: string, title: string): void {
  const frame = document.createElement('iframe')
  frame.setAttribute('aria-hidden', 'true')
  frame.style.position = 'fixed'
  frame.style.width = '0'
  frame.style.height = '0'
  frame.style.border = '0'
  frame.style.right = '0'
  frame.style.bottom = '0'
  const safeTitle = title.replace(/[<>&"]/g, '')
  frame.srcdoc = `<!doctype html><html><head><title>${safeTitle}</title><style>
    @page { margin: 10mm; } html, body { margin: 0; height: 100%; }
    body { display: flex; align-items: center; justify-content: center; }
    img { max-width: 100%; max-height: 100vh; object-fit: contain; }
  </style></head><body><img src="${url}" alt=""></body></html>`
  frame.onload = () => {
    const win = frame.contentWindow
    const img = frame.contentDocument?.querySelector('img')
    const go = () => {
      win?.focus()
      win?.print()
      setTimeout(() => frame.remove(), 60_000)
    }
    if (img && !img.complete) img.onload = go
    else go()
  }
  document.body.appendChild(frame)
}

/** Saves an object URL under a given file name. */
export function saveObjectUrl(url: string, fileName: string): void {
  const a = document.createElement('a')
  a.href = url
  a.download = fileName
  a.rel = 'noopener'
  document.body.appendChild(a)
  a.click()
  a.remove()
}
